function adminCurrencyManagement() {
	let currencyManagement = [
		{
			name: "Currency Management",
			icon: "Currency-management",
			logoName: "MyAccounts",
			// flag: "voucherRequired",
			displayService: "adminCurrencyManagement",
			items: []
		}
	];

	const dashboard = () => {
		const dashboardArr = [
			{
				path: "/index/AdminCurrency-Management",
				name: "Dashboard",
				icon: "dashboard",
				logoName: "dashboard",
				flag: "DASHBOARD"
			}
		];

		return dashboardArr;
	};

	const currencyManagementSub = () => {
		const profileArr = [
			{
				path: "/index/CurrencyMaster",
				name: "Currency Master",
				icon: "CurrencyManagement",
				logoName: "currency master",
				flag: "CURRENCY MASTER"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
		// ) {
		return profileArr;
		// } else {
		//   return "";
		// }
	};

	let a = dashboard();
	let b = currencyManagementSub();

	currencyManagement[0].items = [...a, ...b];

	return currencyManagement;
}

export default adminCurrencyManagement;
